import { ExternalConnectionContact } from '@griply/types';

// Different connections can hold the same person — one suggestion per email, first
// occurrence wins (callers pass lists in connection order).
export const dedupeContacts = (
  contacts: ExternalConnectionContact[],
): ExternalConnectionContact[] => {
  const seen = new Set<string>();
  return contacts.filter(({ email }) => {
    const key = email.toLowerCase();
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
